// extracted by mini-css-extract-plugin
module.exports = {"root":"_1pIuD","icon":"_12gQ0","text":"sdR9C"};